/* AlienGrafic — Ficha de producto (agf-producto.js) · v1 */
(() => {
  if (window.__agfProducto) return;
  window.__agfProducto = true;

  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const DIAS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
  const MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];

  const fmt = cents => '$' + String(Math.round(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  const limite = v => (v.managed === 'shopify' && v.policy === 'deny') ? Math.max(0, v.inv) : Infinity;

  // ---------- Entrega estimada ----------
  function sumarHabiles(desde, n, feriados) {
    const d = new Date(desde.getFullYear(), desde.getMonth(), desde.getDate());
    let sumados = 0;
    while (sumados < n) {
      d.setDate(d.getDate() + 1);
      const clave = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
      if (d.getDay() !== 0 && !feriados.has(clave)) sumados++;
    }
    return d;
  }

  function strong(txt) {
    const s = document.createElement('strong');
    s.textContent = txt;
    return s;
  }

  function textoEntrega(el, min, max, feriadosTxt) {
    const fer = new Set(String(feriadosTxt || '').split(',').map(s => s.trim()).filter(Boolean));
    const hoy = new Date();
    const a = sumarHabiles(hoy, min, fer);
    const b = sumarHabiles(hoy, max, fer);
    const dia = d => `${DIAS[d.getDay()]} ${d.getDate()}`;
    const mes = d => `de ${MESES[d.getMonth()]}`;
    if (min === max) {
      el.replaceChildren('Llega el ', strong(`${dia(a)} ${mes(a)}`));
      return;
    }
    const primero = a.getMonth() === b.getMonth() ? dia(a) : `${dia(a)} ${mes(a)}`;
    el.replaceChildren('Llega entre el ', strong(primero), ' y el ', strong(`${dia(b)} ${mes(b)}`));
  }

  // ---------- Ficha ----------
  function init(root) {
    if (root.dataset.agfReady) return;
    const jsonEl = root.querySelector('[data-agf-json]');
    if (!jsonEl) return;

    let data;
    try {
      data = JSON.parse(jsonEl.textContent);
    } catch (e) {
      console.warn('[agf] JSON inválido', e);
      return;
    }
    root.dataset.agfReady = '1';

    const $ = s => root.querySelector(s);
    const $$ = s => [...root.querySelectorAll(s)];

    const el = {
      price: $('[data-agf-price]'),
      compare: $('[data-agf-compare]'),
      unit: $('[data-agf-unit]'),
      stock: $('[data-agf-stock]'),
      stockTxt: $('[data-agf-stock-text]'),
      badgeOut: $('[data-agf-badge-out]'),
      social: $('[data-ag-social]'),
      variant: $('[data-agf-variant]'),
      qty: $('[data-agf-qty-input]'),
      minus: $('[data-agf-qty-minus]'),
      plus: $('[data-agf-qty-plus]'),
      broches: $('[data-agf-broches]'),
      add: $('[data-agf-add]'),
      addLabel: $('[data-agf-add-label]'),
      buy: $('[data-agf-buy]'),
      error: $('[data-agf-error]'),
      ship: $('[data-agf-ship]'),
      shipText: $('[data-agf-ship-text]'),
      shipFill: $('[data-agf-ship-fill]'),
      shipBar: $('[data-agf-ship-bar]'),
      entrega: $('[data-agf-entrega]')
    };
    const packs = $$('[data-agf-packs] input[type="radio"]');
    const favs = $$('.ag-fav-btn');

    // Barra fija: se mueve al body para que ningún transform del tema la rompa
    const secId = root.dataset.sectionId;
    const sticky = $('[data-agf-sticky]');
    if (sticky) {
      document.querySelectorAll(`body > [data-agf-sticky-for="${secId}"]`).forEach(n => n !== sticky && n.remove());
      document.body.appendChild(sticky);
    }
    const stickyAdd = sticky && sticky.querySelector('[data-agf-sticky-add]');
    const stickySum = sticky && sticky.querySelector('[data-agf-sticky-sum]');

    const state = {
      v: data.variants.find(x => x.id === data.current) || data.variants[0],
      qty: 1,
      pct: 0,
      broches: false,
      cart: 0,
      busy: false
    };
    if (!state.v) return;

    // ---------- Galería ----------
    const galeria = (() => {
      const track = $('[data-agf-track]');
      if (!track) return { irA() {} };
      const slides = [...track.children];
      const thumbs = $$('.agf-thumb');
      const dots = $$('.agf-dot');
      let idx = 0;

      const mediaBox = track.closest('.agf-media');

      // Silenciados al cargar; si el cliente activa el sonido, se respeta al volver
      track.querySelectorAll('video').forEach(vd => { vd.muted = true; });

      const mensaje = (f, yt, vimeo) => {
        try {
          yt.forEach(func => f.contentWindow.postMessage(JSON.stringify({ event: 'command', func, args: [] }), '*'));
          vimeo.forEach(msg => f.contentWindow.postMessage(JSON.stringify(msg), '*'));
        } catch (e) {}
      };

      const videos = activo => slides.forEach((s, k) => {
        const on = k === activo;
        s.querySelectorAll('video').forEach(vd => {
          if (on) {
            const p = vd.play();
            if (p && p.catch) p.catch(() => {});
          } else if (!vd.paused) {
            vd.pause();
          }
        });
        s.querySelectorAll('iframe').forEach(f => {
          if (on) mensaje(f, ['mute', 'playVideo'], [{ method: 'setVolume', value: 0 }, { method: 'play' }]);
          else mensaje(f, ['pauseVideo'], [{ method: 'pause' }]);
        });
      });

      // Espera a que el deslizamiento termine para no arrancar videos intermedios
      let tVid = 0;
      const marcar = i => {
        idx = i;
        thumbs.forEach((t, k) => {
          t.classList.toggle('is-active', k === i);
          t.setAttribute('aria-current', k === i ? 'true' : 'false');
        });
        dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
        if (mediaBox && slides[i]) mediaBox.classList.toggle('is-video', !!slides[i].querySelector('video, iframe'));
        clearTimeout(tVid);
        tVid = setTimeout(() => videos(idx), 150);
      };

      // YouTube/Vimeo cargan diferido: si el video activo termina de cargar, se reproduce
      track.querySelectorAll('iframe').forEach(f => f.addEventListener('load', () => {
        if (slides[idx] && slides[idx].contains(f)) videos(idx);
      }));

      marcar(0);

      const ir = i => {
        i = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
        marcar(i);
      };

      let raf = 0;
      track.addEventListener('scroll', () => {
        if (raf) return;
        raf = requestAnimationFrame(() => {
          raf = 0;
          const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          if (i !== idx && slides[i]) marcar(i);
        });
      }, { passive: true });

      thumbs.forEach((t, k) => t.addEventListener('click', () => ir(k)));

      track.addEventListener('keydown', e => {
        if (e.key === 'ArrowRight') { e.preventDefault(); ir(idx + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); ir(idx - 1); }
      });

      return {
        irA(mediaId) {
          const k = slides.findIndex(s => s.dataset.mediaId === String(mediaId));
          if (k >= 0) ir(k);
        }
      };
    })();

    // ---------- Galería fija en PC: se ubica bajo el header ----------
    const header = document.querySelector('.section-header, sticky-header, header');
    if (header) {
      let rafTop = 0;
      const syncTop = () => {
        rafTop = 0;
        const borde = Math.max(0, header.getBoundingClientRect().bottom);
        root.style.setProperty('--agf-top', `${Math.round(borde) + 24}px`);
        root.style.setProperty('--agf-alto', `${header.offsetHeight + 24}px`);
      };
      const pedir = () => { if (!rafTop) rafTop = requestAnimationFrame(syncTop); };
      window.addEventListener('scroll', pedir, { passive: true });
      window.addEventListener('resize', pedir);
      syncTop();
    }    
    
    // ---------- Cantidad y packs ----------
    function syncPack() {
      if (!packs.length) return;
      const max = limite(state.v);
      let cur = packs.find(p => p.checked);
      if (!cur || (state.v.available && +cur.dataset.qty > max)) {
        const caben = packs.filter(p => +p.dataset.qty <= max);
        cur = caben.length ? caben[caben.length - 1] : packs[0];
        cur.checked = true;
      }
      state.qty = +cur.dataset.qty;
      state.pct = +cur.dataset.pct;
    }

    function clampQty() {
      if (packs.length || !el.qty) return;
      const max = limite(state.v);
      const tope = max === Infinity ? 99 : Math.max(1, max);
      state.qty = Math.min(tope, Math.max(1, parseInt(el.qty.value, 10) || 1));
      el.qty.value = state.qty;
      if (el.minus) el.minus.disabled = state.qty <= 1;
      if (el.plus) el.plus.disabled = state.qty >= tope;
    }

    const subtotal = () => Math.round(state.v.price * state.qty * (100 - state.pct) / 100);
    const extra = () => (state.broches && data.broches) ? data.broches.price : 0;
    const vendible = () => state.v.available && state.qty <= limite(state.v);

    // ---------- Pintado ----------
    function render() {
      const v = state.v;
      const max = limite(v);
      const sub = subtotal();
      const total = sub + extra();
      const ok = vendible();

      // Precio
      el.price.textContent = fmt(sub);
      let ref = 0;
      if (state.pct > 0) ref = v.price * state.qty;
      else if (v.compare > v.price) ref = v.compare * state.qty;
      if (el.compare) {
        el.compare.hidden = !ref;
        el.compare.textContent = ref ? fmt(ref) : '';
      }
      if (el.unit) el.unit.textContent = state.qty > 1 ? `${fmt(sub / state.qty)} c/u` : 'IVA incluido';

      // Stock (misma lógica que el buscador)
      let txt = 'Disponible';
      let cls = 'ok';
      if (!v.available) { txt = 'Agotado'; cls = 'out'; }
      else if (max <= 3) { txt = `Solo ${max} en stock`; cls = 'low'; }
      if (el.stock) {
        el.stock.className = `agf-stock agf-stock--${cls}`;
        el.stockTxt.textContent = txt;
      }
      if (el.badgeOut) el.badgeOut.hidden = v.available;
      if (el.social) el.social.dataset.stock = max === Infinity ? '' : String(max);

      // Packs (en PC, los dos primeros van a media tarjeta y usan bajada corta)
      const anchas = window.matchMedia('(min-width: 990px)').matches;
      packs.forEach((p, i) => {
        const q = +p.dataset.qty;
        const d = +p.dataset.pct;
        const bruto = v.price * q;
        const t = Math.round(bruto * (100 - d) / 100);
        const card = p.closest('.agf-pack');
        const sinStock = v.available && q > max;
        p.disabled = !v.available || sinStock;
        card.classList.toggle('is-disabled', p.disabled);
        card.querySelector('[data-agf-pack-price]').textContent = fmt(t);
        const save = card.querySelector('[data-agf-pack-save]');
        save.textContent = bruto - t > 0 ? `Ahorras ${fmt(bruto - t)}` : 'Sin descuento';
        save.classList.toggle('is-none', bruto - t <= 0);
        const subEl = card.querySelector('[data-agf-pack-sub]');
        if (subEl) {
          const corta = anchas && i < 2;
          subEl.textContent = sinStock
            ? 'Stock insuficiente'
            : (q === 1 ? 'Precio normal' : (corta ? `${fmt(t / q)} c/u` : `${fmt(t / q)} c/u · ${d}% de descuento`));
        }
      });

      // Botones
      const accion = state.qty > 1 ? `Agregar ${state.qty} al carrito` : 'Agregar al carrito';
      const etiqueta = ok ? `${accion} · ${fmt(total)}` : (v.available ? 'Stock insuficiente' : 'Agotado');
      if (!state.busy) {
        el.add.disabled = !ok;
        el.addLabel.textContent = etiqueta;
        if (stickyAdd) {
          stickyAdd.disabled = !ok;
          stickyAdd.textContent = etiqueta;
        }
      }
      if (el.buy) el.buy.disabled = !ok || state.busy;
      if (stickySum) {
        stickySum.textContent = `${state.qty} ${state.qty === 1 ? 'unidad' : 'unidades'}${state.broches ? ' + broches' : ''} · ${fmt(total)}`;
      }

      // Favoritos: variante y precio actuales (en pesos, igual que las tarjetas)
      favs.forEach(b => {
        b.dataset.favVariant = v.id;
        b.dataset.favPrice = Math.round(v.price / 100);
      });

      // Envío gratis
      if (el.ship && data.threshold > 0) {
        const proy = state.cart + (ok ? total : 0);
        const pct = Math.min(100, Math.round(proy / data.threshold * 100));
        el.shipFill.style.width = pct + '%';
        if (el.shipBar) el.shipBar.setAttribute('aria-valuenow', pct);
        let msg;
        if (state.cart >= data.threshold) msg = 'Tu carrito ya tiene envío gratis';
        else if (proy >= data.threshold) msg = 'Con esta selección tienes envío gratis';
        else msg = `Con esta selección te faltan ${fmt(data.threshold - proy)} para envío gratis`;
        el.shipText.textContent = msg;
        el.ship.classList.toggle('is-done', proy >= data.threshold);
      }
    }

    // ---------- Carrito ----------
    async function leerCarrito() {
      try {
        const c = await fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(r => r.json());
        state.cart = c.total_price || 0;
      } catch (e) {}
      render();
    }

    function setBusy(b) {
      state.busy = b;
      [el.add, stickyAdd].forEach(x => {
        if (!x) return;
        x.classList.toggle('is-busy', b);
        x.disabled = b || !vendible();
      });
      if (b) {
        el.addLabel.textContent = 'Agregando…';
        if (stickyAdd) stickyAdd.textContent = 'Agregando…';
      }
    }

    function flash() {
      el.add.classList.add('is-added');
      el.addLabel.textContent = '✓ Agregado';
      setTimeout(() => {
        el.add.classList.remove('is-added');
        render();
      }, 1600);
    }

    async function seccionesCarrito(ids) {
      const r = await fetch(`${ROOT}?sections=${ids.join(',')}`, { headers: { Accept: 'application/json' } });
      return r.ok ? r.json() : null;
    }

    function pintarBurbuja(html) {
      const icon = document.getElementById('cart-icon-bubble');
      if (!icon || !html) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const nuevo = doc.querySelector('.shopify-section');
      if (nuevo) icon.innerHTML = nuevo.innerHTML;
    }

    async function agregar(irAPagar) {
      if (state.busy || !vendible()) return;
      const v = state.v;
      const items = [{ id: v.id, quantity: state.qty }];
      if (state.broches && data.broches) items.push({ id: data.broches.id, quantity: 1 });

      const drawer = document.querySelector('cart-drawer');
      const usaDrawer = !irAPagar && drawer &&
        typeof drawer.renderContents === 'function' &&
        typeof drawer.getSectionsToRender === 'function';
      const ids = usaDrawer ? drawer.getSectionsToRender().map(s => s.id) : ['cart-icon-bubble'];

      const body = { items };
      if (!irAPagar) {
        body.sections = ids.join(',');
        body.sections_url = location.pathname;
      }

      el.error.hidden = true;
      setBusy(true);
      let exito = false;

      try {
        const r = await fetch(ROOT + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        });
        const res = await r.json().catch(() => ({}));
        if (!r.ok || res.status) throw new Error(res.description || res.message || 'No se pudo agregar al carrito.');
        exito = true;
        if (packs.length) logPack('add', { broches: state.broches });

        if (irAPagar) {
          location.href = ROOT + 'checkout';
          return;
        }

        // Si Shopify no devolvió las secciones, se piden aparte (sigue siendo AJAX)
        if (!res.sections) {
          try { res.sections = await seccionesCarrito(ids); } catch (e) {}
        }

        try {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'agf-producto', productVariantId: v.id, cartData: res });
          }
        } catch (e) {}

        if (usaDrawer && res.sections) {
          drawer.classList.remove('is-empty');
          if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(document.activeElement);
          drawer.renderContents(res);
        } else if (res.sections) {
          pintarBurbuja(res.sections['cart-icon-bubble']);
        }
      } catch (e) {
        el.error.textContent = e.message;
        el.error.hidden = false;
      } finally {
        setBusy(false);
        render();
        if (exito && !irAPagar) {
          flash();
          leerCarrito();
        }
      }
    }

        // ---------- Métricas de packs ----------
    const LOG_PACK_URL = 'https://buscador-aliengrafic.xjavieer.workers.dev/log-pack';

    function logPack(tipo, extra) {
      const payload = JSON.stringify(Object.assign({
        tipo: tipo,
        qty: state.qty,
        pct: state.pct
      }, extra || {}));
      try {
        if (navigator.sendBeacon && navigator.sendBeacon(LOG_PACK_URL, payload)) return;
      } catch (e) {}
      try {
        fetch(LOG_PACK_URL, { method: 'POST', body: payload, keepalive: true, headers: { 'Content-Type': 'text/plain' } });
      } catch (e) {}
    }

    // Antirrebote: si el cliente salta entre packs rápido, solo registra el último
    let tLogPack = 0;
    function logVistaPack() {
      clearTimeout(tLogPack);
      tLogPack = setTimeout(() => logPack('vista'), 900);
    }

    // ---------- Eventos ----------
    window.matchMedia('(min-width: 990px)').addEventListener('change', render);
    packs.forEach(p => p.addEventListener('change', () => {
      if (!p.checked) return;
      state.qty = +p.dataset.qty;
      state.pct = +p.dataset.pct;
      render();
      logVistaPack();
    }));

    if (el.qty) {
      el.qty.addEventListener('change', () => { clampQty(); render(); });
      if (el.minus) el.minus.addEventListener('click', () => { el.qty.value = state.qty - 1; clampQty(); render(); });
      if (el.plus) el.plus.addEventListener('click', () => { el.qty.value = state.qty + 1; clampQty(); render(); });
    }

    if (el.broches) {
      el.broches.addEventListener('change', () => {
        state.broches = el.broches.checked;
        render();
      });
    }

    if (el.variant) {
      el.variant.addEventListener('change', () => {
        const nv = data.variants.find(x => String(x.id) === el.variant.value);
        if (!nv) return;
        state.v = nv;
        try {
          const u = new URL(location.href);
          u.searchParams.set('variant', nv.id);
          history.replaceState(history.state, '', u);
        } catch (e) {}
        if (nv.media) galeria.irA(nv.media);
        syncPack();
        clampQty();
        render();
      });
    }

    el.add.addEventListener('click', () => agregar(false));
    if (el.buy) el.buy.addEventListener('click', () => agregar(true));
    if (stickyAdd) stickyAdd.addEventListener('click', () => agregar(false));

    // Cambios hechos desde el cart drawer (quitar, cambiar cantidades)
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, ev => {
          if (!ev || ev.source !== 'agf-producto') leerCarrito();
        });
      }
    } catch (e) {}

    // Barra fija: aparece cuando el botón principal sale de pantalla hacia arriba
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(([e]) => {
        const ver = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', ver);
        sticky.inert = !ver;
        document.body.classList.toggle('agf-sticky-on', ver);
      }).observe(el.add);
    }

    if (el.entrega) textoEntrega(el.entrega, data.entregaMin, data.entregaMax, data.feriados);

    setTimeout(() => {
      if (!window.AGFav) console.warn('[agf] No se encontró AGFav: el JS de favoritos no está cargado en esta página.');
    }, 4000);

    syncPack();
    clampQty();
    render();
    leerCarrito();
  }

  const boot = scope => (scope || document).querySelectorAll('[data-agf]').forEach(init);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();

  document.addEventListener('shopify:section:load', e => boot(e.target));
})();